import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import AOS from "aos"
import Header from "../Header"
import { Helmet } from "react-helmet"
import { Link } from "react-router-dom"
import Navbar from "../Navbar";
import NavbarInOtherPage from "../NavbarInOtherPage"
import DetailsForm from "../DetailsForm";
import Footer from "../Footer"

import "./index.css"

const LogoDesigning = () => {

  useEffect(() => {
    AOS.init({

      duration: 2000
    });
  }, []);

  const mediaQueryCondition = useMediaQuery({ query: '(max-width:1024px)' })


  return (
    <>

      <Helmet>
        <title>Unlocking the Power of Logo Design in Insu Creation: Advantages and Benefits</title>
        <meta name="description" content="Elevate your brand with strategic logo design in insu creation. Discover the advantages of impactful logos, from boosting sales and credibility to gaining a competitive edge. Learn how customized designs can set your business apart and foster brand loyalty." />
        <meta name="keywords" content="Insu Creation, SEO, digital solutions, web development, marketing strategies, branding, SEO, social media marketing, e-commerce, content creation, online presence, business growth, digital innovation, customer engagement, website optimization, digital transformation, digital agency, online marketing, digital strategy, digital consultancy, digital services, digital expertise" />
      </Helmet>
      <Header />
      {mediaQueryCondition ? <Navbar /> : <NavbarInOtherPage />}
      <DetailsForm />
      <div className='transform-main-cont-2'>
        <div className='transform-main-cont'>
          <div>
            <h1 className="transform-head transform-2-head">In insu creation, a logo serves merely as a symbol, not the entirety of a brand. </h1>
            <p className="transform-para transform-2-para">A brand encompasses far more than just a logo; it embodies how your company is distinguished and recalled amidst others, functioning as the very face of your enterprise.</p>
            <ul className="transform-right-list-container">
              <li className="transform-right-list-container-items">
                <div className="list-transform">
                  <img
                    src="https://img.freepik.com/free-icon/check_318-749749.jpg"
                    className="right-check"
                    alt="right-check"
                  />
                  <p className="transform-right-para transform-right-2-para">Crafting a powerful initial impression.</p>
                </div>
              </li>
              <li className="transform-right-list-container-items">
                <div className="list-transform">
                  <img
                    src="https://img.freepik.com/free-icon/check_318-749749.jpg"
                    className="right-check"
                    alt="right-check"
                  />
                  <p className="transform-right-para transform-right-2-para">Cultivating brand recognition.</p>
                </div>
              </li>
              <li className="transform-right-list-container-items">
                <div className="list-transform">
                  <img
                    src="https://img.freepik.com/free-icon/check_318-749749.jpg"
                    className="right-check"
                    alt="right-check"
                  />
                  <p className="transform-right-para transform-right-2-para">Facilitating effective communication.
                  </p>
                </div>
              </li>
              <li className="transform-right-list-container-items">
                <div className="list-transform">
                  <img
                    src="https://img.freepik.com/free-icon/check_318-749749.jpg"
                    className="right-check"
                    alt="right-check"
                  />
                  <p className="transform-right-para transform-right-2-para">Setting a company apart from competitors.</p>
                </div>
              </li>
              <li className="transform-right-list-container-items">
                <div className="list-transform">
                  <img
                    src="https://img.freepik.com/free-icon/check_318-749749.jpg"
                    className="right-check"
                    alt="right-check"
                  />
                  <p className="transform-right-para transform-right-2-para">Enhancing customer loyalty.
                  </p>
                </div>
              </li>
            </ul>
            <div className="no-transform-button-container">
              <Link to="/contactus"><button type="button" className="our-technologies-stack-btn"><p class="btn-main btn-main-m bg-btn2 lnk bg-btn2-m">Request a Quote<i class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></p>
              </button></Link>
              <Link to="/schedule-meeting"> <button type="button" className="no-transform-btn-2">Book an appointment now</button></Link>
            </div>
          </div>
          <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706333172/djowawheneme5skxvwoh.gif" className="seo-route-img-main canva-design-img complete-des-mob-v artile-write-img-vv" alt="seo-route-img-main" />
        </div>
      </div>
      <div className="react-native-business-dev-main" data-aos="zoom-in">
        <div className="react-native-business-dev-main-1 flutter-business-dev-main-1">
          <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706333500/ukcv0zhnrcaitly98ovp.gif" className="react-native-mid-img complete-des-mob-v artile-write-img-vv" alt="" />

          <div className="animation-route-top-con">
            <h1 className="react-native-business-dev your-logo-pd-top">In insu creation, your logo presents a prime opportunity to express your organization's identity distinctly.</h1>
            <p className="react-native-business-dev-para">A logo serves as a visual representation that distinguishes a company or organization, encompassing its offerings and personnel. It embodies the essence of a business.</p>
            <p className="react-native-business-dev-para">Moreover, it's imperative for a logo to be singular, as identical or commonplace logos can lead to trademark conflicts. This can result in significant setbacks, including wasted resources and legal complications. Hence, our commitment lies in furnishing a singular and bespoke logo for your enterprise.</p>

            <button type="button" className="our-technologies-stack-btn"><p class="btn-main btn-main-m bg-btn2 lnk bg-btn2-m">Learn More<i class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></p>
            </button>
          </div>
        </div>
      </div>

      <div className="complete-brand-con-main" data-aos="zoom-in">
        <div className="complete-brand-con">
          <div className="complete-brand-benefits-con">
            <h1 className="branding-benefits">Logo Benefits in Insu Creation</h1>
            <p className="branding-benefits-para">A logo holds numerous advantages in insu creation, as it captures attention, forms a strong initial impression, serves as the bedrock of your brand identity, remains memorable, sets you apart from competitors, fosters brand loyalty, and meets the expectations of your audience.</p>
            <ul>
              <li className="branding-benefits-list-item"># Designs with depth.</li>
              <li className="branding-benefits-list-item"># Tailored Designs.</li>
              <li className="branding-benefits-list-item"># Designs with intent.</li>
              <li className="branding-benefits-list-item"># Designs that complement your business.</li>
            </ul>
            <button type="button" className="our-technologies-stack-btn"><p class="btn-main btn-main-m bg-btn2 lnk bg-btn2-m">Enquire Now <i class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></p>
            </button>
          </div>
          <div>
            <h1 className="branding-benefits branding-benefits-2">Advantages of Logos in Insu Creation</h1>
            <ul className="transform-right-list-container">
              <li className="transform-right-list-container-items-2">
                <div className="list-transform list-transform-brand">
                  <img
                    src="https://img.freepik.com/free-icon/check_318-749749.jpg"
                    className="right-check"
                    alt="right-check"
                  />
                  <p className="transform-right-2-para"> Boost sales and profits.</p>
                </div>
              </li>
              <li className="transform-right-list-container-items-2">
                <div className="list-transform list-transform-brand">
                  <img
                    src="https://img.freepik.com/free-icon/check_318-749749.jpg"
                    className="right-check"
                    alt="right-check"
                  />
                  <p className="transform-right-2-para">Enhance brand recall.</p>
                </div>
              </li>
              <li className="transform-right-list-container-items-2">
                <div className="list-transform list-transform-brand">
                  <img
                    src="https://img.freepik.com/free-icon/check_318-749749.jpg"
                    className="right-check"
                    alt="right-check"
                  />
                  <p className="transform-right-2-para">Bolster sales and profits.</p>
                </div>
              </li>
              <li className="transform-right-list-container-items-2">
                <div className="list-transform list-transform-brand">
                  <img
                    src="https://img.freepik.com/free-icon/check_318-749749.jpg"
                    className="right-check"
                    alt="right-check"
                  />
                  <p className="transform-right-2-para">Elevate stock price.</p>
                </div>
              </li>
              <li className="transform-right-list-container-items-2">
                <div className="list-transform list-transform-brand">
                  <img
                    src="https://img.freepik.com/free-icon/check_318-749749.jpg"
                    className="right-check"
                    alt="right-check"
                  />
                  <p className="ransform-right-2-para">Enhance perceived quality and credibility.</p>
                </div>
              </li>
              <li className="transform-right-list-container-items-2">
                <div className="list-transform list-transform-brand">
                  <img
                    src="https://img.freepik.com/free-icon/check_318-749749.jpg"
                    className="right-check"
                    alt="right-check"
                  />
                  <p className="ransform-right-2-para">Secure strategic advantage over competitors.</p>
                </div>
              </li>
              <li className="transform-right-list-container-items-2">
                <div className="list-transform list-transform-brand">
                  <img
                    src="https://img.freepik.com/free-icon/check_318-749749.jpg"
                    className="right-check"
                    alt="right-check"
                  />
                  <p className="ransform-right-2-para">Expand market share.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>


      <div className="react-native-business-dev-main" data-aos="zoom-in">
        <div className="react-native-business-dev-main-1 flutter-business-dev-main-1">
          <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706333784/xcbyvf8hz6k0b7ky5nev.jpg" className="react-native-mid-img social-media-content-img-n complete-des-mob-v" alt="" />

          <div className="animation-route-top-con">
            <h1 className="react-native-business-dev">In insu creation, logos serve as visual representations of a company's internal essence.</h1>
            <p className="react-native-business-dev-para">When new companies seek logos, adept designers emphasize the necessity of a comprehensive brand identity. Logos form a part of this identity but do not encompass its entirety.</p>
            <p className="react-native-business-dev-para">Through strategic branding, you can elevate your brand from mundane to engaging, forging connections that resonate with consumers and confer a competitive advantage.</p>
            <p className="react-native-business-dev-para">While visual creation is essential, the majority of the process is strategic, especially in the initial stages. Be prepared for extensive thought and decision-making alongside visual development.</p>

            <button type="button" className="our-technologies-stack-btn"><p class="btn-main btn-main-m bg-btn2 lnk bg-btn2-m">Learn More<i class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></p>
            </button>
          </div>

        </div>
      </div>

      <div className="graphic-route-ty-head-main-container" data-aos="fade-up">
        <div className="graphic-route-ty-head-main-container-1">
          <span className="our-locations-contact-us our-wk web-work-w">WE DELIVER OUR BEST</span>
          <h1 className="graphic-route-ty-head logo-design-prev-mob-v">Type of Logos</h1>
          <p className="graphic-route-ty-para logo-design-prev-mob-v-para">There are 6 different types of logos and Insu Creation provides unique designing in any logo type based on your requirements.</p>
          <div className="graphic-route-ty-item-con">
            <div className="graphic-design-ty-list-items mobile-logo-desi-con design-mobile-view-ne">
              <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706334050/bzqucdt7nupnkc7ncrnn.png" alt="" className="graphic-design-route-logos tools-all-detail-con-img" />
              <div className="graphic-design-ty-list-items-div tools-all-detail-con">
                <h1 className="graphic-design-ty-iten-head">Mascot logos</h1>
                <p className="tools-all-detail-con-2">Mascot logos involve an illustrated character that acts as the ambassador of a brand. These types of logos are often fun and friendly and give audiences a persona to relate to and form a connection with. Service companies, food brands, and sports teams are great users of these logotypes.</p>
              </div>
            </div>
            <div className="graphic-design-ty-list-items mobile-logo-desi-con design-mobile-view-ne">
              <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706335563/klmbfm7dk7wpuzvcy0v2.png" alt="" className="graphic-design-route-logos" />
              <div className="graphic-design-ty-list-items-div tools-all-detail-con">
                <h1 className="graphic-design-ty-iten-head">Pictorial Mark</h1>
                <p className="tools-all-detail-con-2">A pictorial mark logo (or a brandmark) is imagery reduced to its symbolistic meaning. This is why, if you’re leaning towards this type of logo design, it has to be extremely representative, containing elements that will make your audience associate it with your brand. Its name is also its symbol, and it works perfectly.</p>
              </div>
            </div>
            <div className="graphic-design-ty-list-items mobile-logo-desi-con design-mobile-view-ne">
              <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706336222/weg8bt50cvpyqdrclxyd.png" alt="" className="graphic-design-route-logos" />
              <div className="graphic-design-ty-list-items-div tools-all-detail-con">
                <h1 className="graphic-design-ty-iten-head">Word Mark</h1>
                <p className="tools-all-detail-con-2">Wordmarks ( word marks) or logotypes are those ensigns that are made by exercising the alphabetical letters of the business name, product, or services. It's the unique text-only typographic treatment of the business name to make it identifiable as the brand identity or logo.</p>
              </div>
            </div>
            <div className="graphic-design-ty-list-items mobile-logo-desi-con design-mobile-view-ne">
              <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706336579/n0quudpk6acm81kigox3.png" alt="" className="graphic-design-route-logos" />
              <div className="graphic-design-ty-list-items-div tools-all-detail-con">
                <h1 className="graphic-design-ty-iten-head">Abstract Mark</h1>
                <p className="tools-all-detail-con-2">Abstract logos draw on the power of imagery to connote the core tenets of the brands they represent. Whether they feature an easily recognizable pictorial image or a more abstract and ambiguous form, abstract logos should be simple yet significant, and make the most of shading and negative space.</p>
              </div>
            </div>
            <div className="graphic-design-ty-list-items mobile-logo-desi-con design-mobile-view-ne">
              <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706336904/g66mqtfsy5afslp9ymmh.jpg" alt="" className="graphic-design-route-logos" />
              <div className="graphic-design-ty-list-items-div tools-all-detail-con">
                <h1 className="graphic-design-ty-iten-head">Combination Logo</h1>
                <p className="tools-all-detail-con-2">The wordmark and symbol in a combination logo can be laid out side-by-side, stacked on top of each other, or integrated together in an image. Because they incorporate both a wordmark and a symbol, combination logos are typically easier to trademark than symbols alone.</p>
              </div>
            </div>
            <div className="graphic-design-ty-list-items mobile-logo-desi-con design-mobile-view-ne">
              <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706337129/ja9usnsokeiuqnigtebs.jpg" alt="" className="graphic-design-route-logos" />
              <div className="graphic-design-ty-list-items-div tools-all-detail-con">
                <h1 className="graphic-design-ty-iten-head">Monogram Logos</h1>
                <p className="tools-all-detail-con-2">From IBM to HBO to YSL, monograms have long extended the simplicity of an acronymic name to a brand’s visual identity, with varying levels of sophistication. The downside of a monogram logo is that, while simple, they can sometimes be difficult to read and harder to remember.</p>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="website-portfolio-chn-container-mm">
        <span className="our-locations-contact-us our-wk web-work-w">WE DELIVER OUR BEST</span>
        <h1 className="portfolio-head-rote mob-web-port-v">Logo Design</h1>
        <p className="portfolio-para-rote web-des-w-page mob-web-port-v-para">Some of our best works.</p>

        <div className="website-portfolio-chn-container">
          <div class="container-chn-n">
            <img src={require('../InsuImages/insuprinting.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                <h1 className="bitm-headi">Insu Printing</h1>
                <p className="bitm-headi-web">Education</p>
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('../InsuImages/newStar.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                <h1 className="bitm-headi">New Star</h1>
                <p className="bitm-headi-web">School</p>
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('../InsuImages/CareerI.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                <h1 className="bitm-headi">CareerI</h1>
                <p className="bitm-headi-web">Hospital</p>
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('../InsuImages/ASWAMWDH.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                <h1 className="bitm-headi">Aswamedh</h1>
                <p className="bitm-headi-web">College</p>
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('../InsuImages/Tagore.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                <h1 className="bitm-headi">Tagore</h1>
                <p className="bitm-headi-web">Hotel</p>
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('../InsuImages/Joyguru.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                <h1 className="bitm-headi">Joyguru</h1>
                <p className="bitm-headi-web">Hospital</p>
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('../InsuImages/LBC.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                <h1 className="bitm-headi">LBC</h1>
                <p className="bitm-headi-web">Interior</p>
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('../InsuImages/BiryanI.png')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                <h1 className="bitm-headi">BiryanI</h1>
                <p className="bitm-headi-web">Hotel</p>
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('../InsuImages/eparebangla.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p>
              </div>
            </div>
          </div>








          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy1_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy2_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy3_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          {/* <div class="container-chn-n">
            <img src={require('./insuLogo/dummy4_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p>
              </div>
            </div>
          </div> */}

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy5_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy6_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy7_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy8_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy9_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy10_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy11_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy12_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy13_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy14_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy15_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy16_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy17_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy18_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy19_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy20_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy21_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy22_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy23_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy24_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy25_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy26_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy27_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy28_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy29_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy30_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy31_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy32_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy33_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy34_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy35_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>
          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy36_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy37_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy38_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy39_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy40_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy41_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy42_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy43_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy44_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy45_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy46_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy47_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy48_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy49_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy50_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy51_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy52_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy53_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy54_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy55_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy56_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

          <div class="container-chn-n">
            <img src={require('./insuLogo/dummy57_logo.jpg')} alt="Avatar" class="image-chn-n" />
            <div class="overlay-chn-n">
              <div class="text-chn-nn">
                {/* <h1 className="bitm-headi">Eparebangla</h1>
                <p className="bitm-headi-web">Hotel</p> */}
              </div>
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </>
  )
}
AOS.init()
export default LogoDesigning;

























































// import React, { useState, useEffect } from "react";
// import { useMediaQuery } from "react-responsive";
// import AOS from "aos"
// import Header from "../Header"
// import { Helmet } from "react-helmet"
// import { Link } from "react-router-dom"
// import Navbar from "../Navbar";
// import NavbarInOtherPage from "../NavbarInOtherPage"
// import DetailsForm from "../DetailsForm";
// import Footer from "../Footer"

// import "./index.css"


// import img1 from '../InsuImages/insuprinting.jpg';
// import img2 from '../InsuImages/newStar.jpg';
// import img3 from '../InsuImages/CareerI.jpg';
// import img4 from '../InsuImages/ASWAMWDH.jpg';
// import img5 from '../InsuImages/Tagore.jpg';
// import img6 from '../InsuImages/Joyguru.jpg';
// import img7 from '../InsuImages/LBC.jpg';
// import img8 from '../InsuImages/BiryanI.png';
// import img9 from '../InsuImages/eparebangla.jpg';



// const LogoDesigning = () => {

//   // const [projects, setProjects] = useState([]);

//   // useEffect(() => {
//   //   const fetchProjects = async () => {
//   //     try {
//   //       const response = await fetch('http://localhost:5000/api/logos');
//   //       const data = await response.json();
//   //       setProjects(data);
//   //     } catch (error) {
//   //       console.error("Error fetching projects:", error);
//   //     }
//   //   };

//   //   fetchProjects();
//   // }, []);


//   // console.log(projects);
//   // useEffect(() => {
//   //   AOS.init({

//   //     duration: 2000
//   //   });
//   // }, []);

//   const mediaQueryCondition = useMediaQuery({ query: '(max-width:1024px)' })

//   const projects = [
//     { img: img1, title: 'Insu Printing', type: 'Education' },
//     { img: img2, title: 'New Star', type: 'School' },
//     { img: img3, title: 'CareerI', type: 'Hospital' },
//     { img: img4, title: 'Aswamedh', type: 'College' },
//     { img: img5, title: 'Tagore', type: 'Hotel' },
//     { img: img6, title: 'Joyguru', type: 'Hospital' },
//     { img: img7, title: 'LBC', type: 'Interior' },
//     { img: img8, title: 'BiryanI', type: 'Hotel' },
//     { img: img9, title: 'Eparebangla', type: 'Hotel' },
//   ];

//   return (
//     <>

//       <Helmet>
//         <title>Unlocking the Power of Logo Design in Insu Creation: Advantages and Benefits</title>
//         <meta name="description" content="Elevate your brand with strategic logo design in insu creation. Discover the advantages of impactful logos, from boosting sales and credibility to gaining a competitive edge. Learn how customized designs can set your business apart and foster brand loyalty." />
//         <meta name="keywords" content="Insu Creation, SEO, digital solutions, web development, marketing strategies, branding, SEO, social media marketing, e-commerce, content creation, online presence, business growth, digital innovation, customer engagement, website optimization, digital transformation, digital agency, online marketing, digital strategy, digital consultancy, digital services, digital expertise" />
//       </Helmet>
//       <Header />
//       {mediaQueryCondition ? <Navbar /> : <NavbarInOtherPage />}
//       <DetailsForm />
//       <div className='transform-main-cont-2'>
//         <div className='transform-main-cont'>
//           <div>
//             <h1 className="transform-head transform-2-head">In insu creation, a logo serves merely as a symbol, not the entirety of a brand. </h1>
//             <p className="transform-para transform-2-para">A brand encompasses far more than just a logo; it embodies how your company is distinguished and recalled amidst others, functioning as the very face of your enterprise.</p>
//             <ul className="transform-right-list-container">
//               <li className="transform-right-list-container-items">
//                 <div className="list-transform">
//                   <img
//                     src="https://img.freepik.com/free-icon/check_318-749749.jpg"
//                     className="right-check"
//                     alt="right-check"
//                   />
//                   <p className="transform-right-para transform-right-2-para">Crafting a powerful initial impression.</p>
//                 </div>
//               </li>
//               <li className="transform-right-list-container-items">
//                 <div className="list-transform">
//                   <img
//                     src="https://img.freepik.com/free-icon/check_318-749749.jpg"
//                     className="right-check"
//                     alt="right-check"
//                   />
//                   <p className="transform-right-para transform-right-2-para">Cultivating brand recognition.</p>
//                 </div>
//               </li>
//               <li className="transform-right-list-container-items">
//                 <div className="list-transform">
//                   <img
//                     src="https://img.freepik.com/free-icon/check_318-749749.jpg"
//                     className="right-check"
//                     alt="right-check"
//                   />
//                   <p className="transform-right-para transform-right-2-para">Facilitating effective communication.
//                   </p>
//                 </div>
//               </li>
//               <li className="transform-right-list-container-items">
//                 <div className="list-transform">
//                   <img
//                     src="https://img.freepik.com/free-icon/check_318-749749.jpg"
//                     className="right-check"
//                     alt="right-check"
//                   />
//                   <p className="transform-right-para transform-right-2-para">Setting a company apart from competitors.</p>
//                 </div>
//               </li>
//               <li className="transform-right-list-container-items">
//                 <div className="list-transform">
//                   <img
//                     src="https://img.freepik.com/free-icon/check_318-749749.jpg"
//                     className="right-check"
//                     alt="right-check"
//                   />
//                   <p className="transform-right-para transform-right-2-para">Enhancing customer loyalty.
//                   </p>
//                 </div>
//               </li>
//             </ul>
//             <div className="no-transform-button-container">
//               <Link to="/contactus"><button type="button" className="our-technologies-stack-btn"><p class="btn-main btn-main-m bg-btn2 lnk bg-btn2-m">Request a Quote<i class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></p>
//               </button></Link>
//               <Link to="/schedule-meeting"> <button type="button" className="no-transform-btn-2">Book an appointment now</button></Link>
//             </div>
//           </div>
//           <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706333172/djowawheneme5skxvwoh.gif" className="seo-route-img-main canva-design-img complete-des-mob-v artile-write-img-vv" alt="seo-route-img-main" />
//         </div>
//       </div>
//       <div className="react-native-business-dev-main" data-aos="zoom-in">
//         <div className="react-native-business-dev-main-1 flutter-business-dev-main-1">
//           <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706333500/ukcv0zhnrcaitly98ovp.gif" className="react-native-mid-img complete-des-mob-v artile-write-img-vv" alt="" />

//           <div className="animation-route-top-con">
//             <h1 className="react-native-business-dev your-logo-pd-top">In insu creation, your logo presents a prime opportunity to express your organization's identity distinctly.</h1>
//             <p className="react-native-business-dev-para">A logo serves as a visual representation that distinguishes a company or organization, encompassing its offerings and personnel. It embodies the essence of a business.</p>
//             <p className="react-native-business-dev-para">Moreover, it's imperative for a logo to be singular, as identical or commonplace logos can lead to trademark conflicts. This can result in significant setbacks, including wasted resources and legal complications. Hence, our commitment lies in furnishing a singular and bespoke logo for your enterprise.</p>

//             <button type="button" className="our-technologies-stack-btn"><p class="btn-main btn-main-m bg-btn2 lnk bg-btn2-m">Learn More<i class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></p>
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="complete-brand-con-main" data-aos="zoom-in">
//         <div className="complete-brand-con">
//           <div className="complete-brand-benefits-con">
//             <h1 className="branding-benefits">Logo Benefits in Insu Creation</h1>
//             <p className="branding-benefits-para">A logo holds numerous advantages in insu creation, as it captures attention, forms a strong initial impression, serves as the bedrock of your brand identity, remains memorable, sets you apart from competitors, fosters brand loyalty, and meets the expectations of your audience.</p>
//             <ul>
//               <li className="branding-benefits-list-item"># Designs with depth.</li>
//               <li className="branding-benefits-list-item"># Tailored Designs.</li>
//               <li className="branding-benefits-list-item"># Designs with intent.</li>
//               <li className="branding-benefits-list-item"># Designs that complement your business.</li>
//             </ul>
//             <button type="button" className="our-technologies-stack-btn"><p class="btn-main btn-main-m bg-btn2 lnk bg-btn2-m">Enquire Now <i class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></p>
//             </button>
//           </div>
//           <div>
//             <h1 className="branding-benefits branding-benefits-2">Advantages of Logos in Insu Creation</h1>
//             <ul className="transform-right-list-container">
//               <li className="transform-right-list-container-items-2">
//                 <div className="list-transform list-transform-brand">
//                   <img
//                     src="https://img.freepik.com/free-icon/check_318-749749.jpg"
//                     className="right-check"
//                     alt="right-check"
//                   />
//                   <p className="transform-right-2-para"> Boost sales and profits.</p>
//                 </div>
//               </li>
//               <li className="transform-right-list-container-items-2">
//                 <div className="list-transform list-transform-brand">
//                   <img
//                     src="https://img.freepik.com/free-icon/check_318-749749.jpg"
//                     className="right-check"
//                     alt="right-check"
//                   />
//                   <p className="transform-right-2-para">Enhance brand recall.</p>
//                 </div>
//               </li>
//               <li className="transform-right-list-container-items-2">
//                 <div className="list-transform list-transform-brand">
//                   <img
//                     src="https://img.freepik.com/free-icon/check_318-749749.jpg"
//                     className="right-check"
//                     alt="right-check"
//                   />
//                   <p className="transform-right-2-para">Bolster sales and profits.</p>
//                 </div>
//               </li>
//               <li className="transform-right-list-container-items-2">
//                 <div className="list-transform list-transform-brand">
//                   <img
//                     src="https://img.freepik.com/free-icon/check_318-749749.jpg"
//                     className="right-check"
//                     alt="right-check"
//                   />
//                   <p className="transform-right-2-para">Elevate stock price.</p>
//                 </div>
//               </li>
//               <li className="transform-right-list-container-items-2">
//                 <div className="list-transform list-transform-brand">
//                   <img
//                     src="https://img.freepik.com/free-icon/check_318-749749.jpg"
//                     className="right-check"
//                     alt="right-check"
//                   />
//                   <p className="ransform-right-2-para">Enhance perceived quality and credibility.</p>
//                 </div>
//               </li>
//               <li className="transform-right-list-container-items-2">
//                 <div className="list-transform list-transform-brand">
//                   <img
//                     src="https://img.freepik.com/free-icon/check_318-749749.jpg"
//                     className="right-check"
//                     alt="right-check"
//                   />
//                   <p className="ransform-right-2-para">Secure strategic advantage over competitors.</p>
//                 </div>
//               </li>
//               <li className="transform-right-list-container-items-2">
//                 <div className="list-transform list-transform-brand">
//                   <img
//                     src="https://img.freepik.com/free-icon/check_318-749749.jpg"
//                     className="right-check"
//                     alt="right-check"
//                   />
//                   <p className="ransform-right-2-para">Expand market share.</p>
//                 </div>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>


//       <div className="react-native-business-dev-main" data-aos="zoom-in">
//         <div className="react-native-business-dev-main-1 flutter-business-dev-main-1">
//           <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706333784/xcbyvf8hz6k0b7ky5nev.jpg" className="react-native-mid-img social-media-content-img-n complete-des-mob-v" alt="" />

//           <div className="animation-route-top-con">
//             <h1 className="react-native-business-dev">In insu creation, logos serve as visual representations of a company's internal essence.</h1>
//             <p className="react-native-business-dev-para">When new companies seek logos, adept designers emphasize the necessity of a comprehensive brand identity. Logos form a part of this identity but do not encompass its entirety.</p>
//             <p className="react-native-business-dev-para">Through strategic branding, you can elevate your brand from mundane to engaging, forging connections that resonate with consumers and confer a competitive advantage.</p>
//             <p className="react-native-business-dev-para">While visual creation is essential, the majority of the process is strategic, especially in the initial stages. Be prepared for extensive thought and decision-making alongside visual development.</p>

//             <button type="button" className="our-technologies-stack-btn"><p class="btn-main btn-main-m bg-btn2 lnk bg-btn2-m">Learn More<i class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></p>
//             </button>
//           </div>

//         </div>
//       </div>

//       <div className="graphic-route-ty-head-main-container" data-aos="fade-up">
//         <div className="graphic-route-ty-head-main-container-1">
//           <span className="our-locations-contact-us our-wk web-work-w">WE DELIVER OUR BEST</span>
//           <h1 className="graphic-route-ty-head logo-design-prev-mob-v">Type of Logos</h1>
//           <p className="graphic-route-ty-para logo-design-prev-mob-v-para">There are 6 different types of logos and Insu Creation provides unique designing in any logo type based on your requirements.</p>
//           <div className="graphic-route-ty-item-con">
//             <div className="graphic-design-ty-list-items mobile-logo-desi-con design-mobile-view-ne">
//               <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706334050/bzqucdt7nupnkc7ncrnn.png" alt="" className="graphic-design-route-logos tools-all-detail-con-img" />
//               <div className="graphic-design-ty-list-items-div tools-all-detail-con">
//                 <h1 className="graphic-design-ty-iten-head">Mascot logos</h1>
//                 <p className="tools-all-detail-con-2">Mascot logos involve an illustrated character that acts as the ambassador of a brand. These types of logos are often fun and friendly and give audiences a persona to relate to and form a connection with. Service companies, food brands, and sports teams are great users of these logotypes.</p>
//               </div>
//             </div>
//             <div className="graphic-design-ty-list-items mobile-logo-desi-con design-mobile-view-ne">
//               <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706335563/klmbfm7dk7wpuzvcy0v2.png" alt="" className="graphic-design-route-logos" />
//               <div className="graphic-design-ty-list-items-div tools-all-detail-con">
//                 <h1 className="graphic-design-ty-iten-head">Pictorial Mark</h1>
//                 <p className="tools-all-detail-con-2">A pictorial mark logo (or a brandmark) is imagery reduced to its symbolistic meaning. This is why, if you’re leaning towards this type of logo design, it has to be extremely representative, containing elements that will make your audience associate it with your brand. Its name is also its symbol, and it works perfectly.</p>
//               </div>
//             </div>
//             <div className="graphic-design-ty-list-items mobile-logo-desi-con design-mobile-view-ne">
//               <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706336222/weg8bt50cvpyqdrclxyd.png" alt="" className="graphic-design-route-logos" />
//               <div className="graphic-design-ty-list-items-div tools-all-detail-con">
//                 <h1 className="graphic-design-ty-iten-head">Word Mark</h1>
//                 <p className="tools-all-detail-con-2">Wordmarks ( word marks) or logotypes are those ensigns that are made by exercising the alphabetical letters of the business name, product, or services. It's the unique text-only typographic treatment of the business name to make it identifiable as the brand identity or logo.</p>
//               </div>
//             </div>
//             <div className="graphic-design-ty-list-items mobile-logo-desi-con design-mobile-view-ne">
//               <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706336579/n0quudpk6acm81kigox3.png" alt="" className="graphic-design-route-logos" />
//               <div className="graphic-design-ty-list-items-div tools-all-detail-con">
//                 <h1 className="graphic-design-ty-iten-head">Abstract Mark</h1>
//                 <p className="tools-all-detail-con-2">Abstract logos draw on the power of imagery to connote the core tenets of the brands they represent. Whether they feature an easily recognizable pictorial image or a more abstract and ambiguous form, abstract logos should be simple yet significant, and make the most of shading and negative space.</p>
//               </div>
//             </div>
//             <div className="graphic-design-ty-list-items mobile-logo-desi-con design-mobile-view-ne">
//               <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706336904/g66mqtfsy5afslp9ymmh.jpg" alt="" className="graphic-design-route-logos" />
//               <div className="graphic-design-ty-list-items-div tools-all-detail-con">
//                 <h1 className="graphic-design-ty-iten-head">Combination Logo</h1>
//                 <p className="tools-all-detail-con-2">The wordmark and symbol in a combination logo can be laid out side-by-side, stacked on top of each other, or integrated together in an image. Because they incorporate both a wordmark and a symbol, combination logos are typically easier to trademark than symbols alone.</p>
//               </div>
//             </div>
//             <div className="graphic-design-ty-list-items mobile-logo-desi-con design-mobile-view-ne">
//               <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1706337129/ja9usnsokeiuqnigtebs.jpg" alt="" className="graphic-design-route-logos" />
//               <div className="graphic-design-ty-list-items-div tools-all-detail-con">
//                 <h1 className="graphic-design-ty-iten-head">Monogram Logos</h1>
//                 <p className="tools-all-detail-con-2">From IBM to HBO to YSL, monograms have long extended the simplicity of an acronymic name to a brand’s visual identity, with varying levels of sophistication. The downside of a monogram logo is that, while simple, they can sometimes be difficult to read and harder to remember.</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>



//       <div className="website-portfolio-chn-container-mm">
//         <span className="our-locations-contact-us our-wk web-work-w">WE DELIVER OUR BEST</span>
//         <h1 className="portfolio-head-rote mob-web-port-v">Logo Design</h1>
//         <p className="portfolio-para-rote web-des-w-page mob-web-port-v-para">Some of our best works.</p>

//         <div className="website-portfolio-chn-container">
//           {projects.length > 0 ? (
//             projects.map((project, index) => (
//               <div className="container-chn-n" key={index}>
//                 <img src={project.imageUrl} alt="Avatar" className="image-chn-n" />
//                 <div className="overlay-chn-n">
//                   <div className="text-chn-nn">
//                     <h1 className="bitm-headi">{project.title}</h1>
//                     <p className="bitm-headi-web">{project.type}</p>
//                   </div>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <p>Loading projects...</p>
//           )}
//         </div>
//       </div>
//       <Footer />
//     </>
//   )
// }
// AOS.init()
// export default LogoDesigning;